module.exports = __webpack_public_path__ + "img/wx.86df1610.png";